// Currency / number formatting helpers used by the results-panel components.
// Centralized so the wizard, the dashboard, and the PDF template share a
// single rendering of "$2,065,000" vs "$2.065M" etc.

const USD = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });

export function formatUSD(value) {
  if (value == null || !Number.isFinite(Number(value))) return '—';
  return USD.format(Math.round(Number(value)));
}

// Compact: $2.07M / $200K / $750. For headline numbers where a comma-
// separated 7-digit figure is too noisy. Uses Math.round on the integer
// hundredths to dodge IEEE-754 surprises like (2.065).toFixed(2) === "2.06".
export function formatUSDCompact(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  const abs = Math.abs(n);
  if (abs >= 1_000_000) {
    const m = Math.round(n / 10_000) / 100;
    const trimmed = m.toFixed(2).replace(/\.?0+$/, '');
    return `$${trimmed}M`;
  }
  if (abs >= 1_000) return `$${Math.round(n / 1_000)}K`;
  return USD.format(Math.round(n));
}

export function formatSamples(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return n.toLocaleString('en-US');
}

// Convert a decimal multiplier to a signed percentage string.
// 0.90 → "−10%", 1.40 → "+40%", 1.0 → null (no adjustment).
export function formatMultiplierAsPct(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n === 1) return null;
  const pct = Math.round((n - 1) * 100);
  return pct > 0 ? `+${pct}%` : `−${Math.abs(pct)}%`;
}
